import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "q-pa-md" };
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = {
    key: 0,
    class: "text-center q-mt-lg"
};
const _hoisted_4 = { class: "row justify-center" };
const _hoisted_5 = {
    key: 1,
    class: "q-mt-lg row justify-center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_checkbox = _resolveComponent("q-checkbox");
    const _component_q_btn = _resolveComponent("q-btn");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
            innerHTML: _ctx.taikyoHtml.value
        }, null, 8, _hoisted_2),
        _cache[3] || (_cache[3] = _createElementVNode("div", null, null, -1)),
        (_ctx.taikyoEntity.taikyoKanryoDate === undefined)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_q_checkbox, {
                    modelValue: _ctx.check.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.check.value) = $event)),
                    color: "red-9",
                    class: "text-h6 text-red-9 text-weight-bold"
                }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                            _createTextVNode(" 上記注意事項を確認し、解約通知案内に従って退去作業を完了しました。 ", -1)
                        ]))]),
                    _: 1
                }, 8, ["modelValue"]),
                _cache[2] || (_cache[2] = _createElementVNode("p", null, null, -1)),
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_q_btn, {
                        class: "btn-route col-8 col-md-4",
                        disable: !_ctx.check.value,
                        label: "退去",
                        color: "green-7",
                        onClick: _ctx.taikyoComp
                    }, null, 8, ["disable", "onClick"])
                ])
            ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_q_btn, {
                    class: "btn-route col-8 col-md-4",
                    disable: true,
                    label: "退去済み",
                    color: "grey-6"
                })
            ]))
    ]));
}
